// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash';
import SecurityDashboardsDetailList from './SecurityDashboardsDetailList';
// css
import '../../styles/components/analytics/SecurityDashboardsDetail.scss';


class SecurityDashboardsDetail extends Component {

  renderSubcategories() {
    const { subcategories } = this.props.category;
    const chunks = [
      [subcategories[0]],
      [subcategories[1], subcategories[2]],
      [subcategories[3], subcategories[4]]
    ].map(chunk => compact(chunk));

    return chunks.map((chunk, index) => (
      <div key={index} className='col-md-4'>
        {chunk.map((subcategory, index) => (
          <SecurityDashboardsDetailList
            key={index}
            subcategory={subcategory}
          />
        ))}
      </div>
    ));
  }

  render() {
    const { category } = this.props;

    return (
      <div className='analytics__security-dashboards-detail' id={this.props.pptxTarget}>
        <h2>Security Recommendation: {category.title} Dashboards</h2>
        <div className='box'>
          <div className='row'>
            {this.renderSubcategories()}
          </div>
        </div>
      </div>
    );
  }
}

SecurityDashboardsDetail.propTypes = {
  category: PropTypes.object.isRequired,
  pptxTarget: PropTypes.string
};

export default SecurityDashboardsDetail;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityDashboardsDetail.js